import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function PricingSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [currentPrice, setCurrentPrice] = useState(37);
  useEffect(() => {
    const isExpired = document.cookie.split('; ').find(row => row.startsWith('priceExpired='))?.split('=')[1] === 'true';
    if (isExpired) {
      setCurrentPrice(97);
    }
  }, []);
  return <section ref={ref} className="w-full py-20 px-4" data-id="element-291">
      <div className="max-w-6xl mx-auto" data-id="element-292">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-293">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-294">
            Empieza a Ganar Esta Semana por{' '}
            <span className="text-gold" data-id="element-295">${currentPrice}</span>
          </h2>
          <p className="font-body text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-296">
            {currentPrice === 37 ? 'El precio de lanzamiento es $37 (pago único). Sube a $97 pronto.' : 'Precio actual: $97 (pago único). La oferta de lanzamiento ha expirado.'}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-gradient-to-br from-navy-dark to-navy border-2 border-gold/30 rounded-2xl p-8 md:p-12 mb-8" data-id="element-297">
          {/* Product Image */}
          <div className="mb-8" data-id="element-298">
            <motion.img initial={{
            opacity: 0,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} src="https://cdn.magicpatterns.com/uploads/ehm6JeHJmPrRFh28GURN6r/ai_web_closer_bundle_mockup.png" alt="AI Web Closer System - Complete bundle showing dashboard, AI brains, modules, closing script, price calculator, and $50M+ generated proof" className="w-full h-auto rounded-lg" data-id="element-299" />
          </div>

          <div className="text-center mb-8" data-id="element-300">
            <h3 className="font-heading font-bold text-2xl md:text-3xl mb-4" data-id="element-301">
              Acceso al Curso Completo
            </h3>
            <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-302">
              {currentPrice === 97 && <span className="font-heading font-bold text-3xl text-gray-500 line-through mr-2" data-id="element-303">
                  $37
                </span>}
              <span className="font-heading font-black text-5xl md:text-6xl text-gold" data-id="element-304">
                ${currentPrice}
              </span>
              <span className="font-body text-lg text-gray-400" data-id="element-305">
                pago único
              </span>
            </div>
            <p className="font-body text-sm text-gray-400" data-id="element-306">
              Incluye todos los módulos, cerebros de IA, guiones y calculadora
            </p>
          </div>

          <motion.a href="/checkout" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group w-full bg-gold hover:bg-gold-light text-navy font-heading font-bold text-xl px-8 py-5 rounded-xl shadow-2xl transition-all duration-300 flex items-center justify-center gap-3 mb-8" data-id="element-307">
            QUIERO ACCESO POR ${currentPrice}
            <ArrowRightIcon className="h-6 w-6 group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-308" />
          </motion.a>

          <div className="border-t border-gold/20 pt-8 mt-8" data-id="element-309">
            <p className="font-body text-base text-gray-300 mb-6 text-center" data-id="element-310">
              Además del curso, necesitarás acceso al software de IA:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-311">
              <div className="bg-navy-light border border-gold/20 rounded-xl p-6" data-id="element-312">
                <div className="flex items-center gap-2 mb-4" data-id="element-313">
                  <CheckIcon className="h-5 w-5 text-gold flex-shrink-0" aria-hidden="true" data-id="element-314" />
                  <h4 className="font-heading font-bold text-lg" data-id="element-315">Plan Anual</h4>
                </div>
                <div className="flex items-baseline gap-2 mb-2" data-id="element-316">
                  <span className="font-heading font-black text-3xl text-gold" data-id="element-317">
                    $20
                  </span>
                  <span className="font-body text-sm text-gray-400" data-id="element-318">/mes</span>
                </div>
                <p className="font-body text-sm text-gray-400" data-id="element-319">
                  (facturado anualmente)
                </p>
              </div>

              <div className="bg-navy-light border border-gold/20 rounded-xl p-6" data-id="element-320">
                <div className="flex items-center gap-2 mb-4" data-id="element-321">
                  <CheckIcon className="h-5 w-5 text-gold flex-shrink-0" aria-hidden="true" data-id="element-322" />
                  <h4 className="font-heading font-bold text-lg" data-id="element-323">
                    Plan Mensual
                  </h4>
                </div>
                <div className="flex items-baseline gap-2 mb-2" data-id="element-324">
                  <span className="font-heading font-black text-3xl text-gold" data-id="element-325">
                    $40
                  </span>
                  <span className="font-body text-sm text-gray-400" data-id="element-326">/mes</span>
                </div>
                <p className="font-body text-sm text-gray-400" data-id="element-327">
                  (sin compromiso)
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="bg-gold/10 border border-gold/30 rounded-xl p-6 text-center" data-id="element-328">
          <p className="font-body text-base text-gray-300" data-id="element-329">
            ⚠️ Este precio de lanzamiento desaparece pronto. Accede ahora antes
            de que suba.
          </p>
        </motion.div>
      </div>
    </section>;
}